import { UserRole } from '@/lib/types';
import { useAuthContext } from '@/contexts/AuthContext';

const useHasUserRole = (role: UserRole) => {
  const { user } = useAuthContext();

  return user?.roles.some((r) => r.name === role) || false;
};

export default useHasUserRole;
